import { Report } from '../types';

export type IndicatorColor = 'green' | 'yellow' | 'orange' | 'red';

export interface ResultLabel {
  label: string;
  /** null: no saved indicators (the header then keeps its neutral colour) */
  color: IndicatorColor | null;
}

/**
 * The Result shown in the review header.
 * - New reports save it (R1h): uiIndicators.label, with its colour. It includes
 *   "Review Required" (orange) when reference ranges could not be confirmed.
 * - Older reports saved only the badge, computed with the flags in the same step: it says
 *   the same thing, so it is shown.
 * - Without indicators, saved flags give the same label the backend would
 *   (Critical / Review Required / Minor Abnormalities).
 * - Otherwise "Normal", as before.
 */
export function resultLabel(report: Pick<Report, 'uiIndicators' | 'flags'> | null | undefined): ResultLabel {
  const indicators = report?.uiIndicators;
  const color = indicators?.color ?? null;
  if (indicators?.label && indicators.label.trim()) return { label: indicators.label, color };
  if (indicators?.badge && indicators.badge.trim()) return { label: indicators.badge, color };

  const flags = report?.flags;
  if (flags?.requiresUrgentAttention) return { label: 'Critical', color: 'red' };
  if (flags?.requiresAttention) return { label: 'Review Required', color: 'orange' };
  if (flags?.hasAbnormalValues) return { label: 'Minor Abnormalities', color: 'yellow' };
  return { label: 'Normal', color };
}
